/**
 * Created by netre on 27.06.2017.
 */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cx from 'classnames';
import { translate } from 'react-i18next';

import {
  clearTooltip,
  holdDown,
  setTooltip,
} from '../../../sagas/devices/actions';
import { isRecentAction } from '../../../utils/helpers';
import { ignitionClick, setAutorunEngineDelayClick, setWebasto } from '../../Sidebar/actions';
import { IgnitionAutorun } from './IgnitionAutorun';

@connect(
  state => ({
    ignitionOn: state.devices.currentDeviceStats.ignitionOn,
    deviceId: state.devices.currentDevice.id,
    ignitionState: state.devices.ignitionState[state.devices.currentDevice.id] || 0,
    supportAutorunEngineDelay: state.devices.currentDevice.supportAutorunEngineDelay,
    currentDevice: state.devices.currentDevice,
  }),
  dispatch => ({
    toggleIgnition({ deviceId, on }) {
      return dispatch(ignitionClick({ deviceId, on }));
    },
    setTooltip({ type }) {
      return dispatch(setTooltip({ type }));
    },
    clearTooltip() {
      return dispatch(clearTooltip());
    },
    toggleWebasto({ deviceId, on }) {
      return dispatch(setWebasto({ deviceId, on }));
    },
    handleAutorunEngineDelayInSeconds({ deviceId, seconds }) {
      return dispatch(setAutorunEngineDelayClick({ deviceId, seconds }));
    },
  }),
)
@translate(['dashboard-sidebar'], { wait: true })
export class IgnitionButton extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      autorunMenuOpened: false,
    };
  }

  onAutorunClickOutside = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.target !== this.openAutorunBtn) {
      this.setState({
        autorunMenuOpened: false,
      });
    }
  };

  setWebastoOn = (e) => {
    this.props.toggleWebasto({
      deviceId: this.props.currentDevice.id,
      on: e.target.checked,
    });
  };

  setSeconds = (e, decrease = false) => {
    e.preventDefault();
    const minutes = Math.round(this.props.currentDevice.autorunEngineDelayInSeconds / 60);
    if ((minutes === 2 && decrease) || (minutes === 30 && !decrease)) return;
    let newSeconds = (minutes + (((-1) ** (Number(decrease))) * 5)) * 60;
    if (newSeconds > 1800) newSeconds = 1800;
    if (newSeconds < 120) newSeconds = 120;
    if (minutes === 2 && !decrease) newSeconds = 300;
    this.props.handleAutorunEngineDelayInSeconds({
      deviceId: this.props.currentDevice.id,
      seconds: newSeconds,
    });
  };

  clickHandler = (e) => {
    e.preventDefault();
    clearInterval(this.animationInterval);
  };
  mouseDownHandler = (e) => {
    const { handleAnimationState, toggleIgnition } = this.props;
    e.preventDefault();
    if (e.target !== this.openAutorunBtn) {
      handleAnimationState(true);
      this.progress = 0;

      this.animationInterval = setInterval(() => {
        this.progress += 1;
        if (this.progress > 99) {
          this.progress = -1;
          clearInterval(this.animationInterval);
          toggleIgnition({
            deviceId: this.props.deviceId,
            on: this.props.ignitionOn,
          });
          handleAnimationState(false);
        }
      }, 3000 / 100);

      this.showHoldTooltip();
    }
  };
  mouseUpHandler = (e) => {
    e.preventDefault();
    this.hideHoldTooltip();
    clearInterval(this.animationInterval);
    this.props.handleAnimationState(false);
  };

  showHoldTooltip = () => {
    this.props.setTooltip({
      type: holdDown,
    });
  };

  hideHoldTooltip = () => {
    if (this.progress <= 99 && this.progress !== -1) {
      this.hideTooltip(0);
      this.progress = 0;
    }
  };
  hideTooltip = (delay) => {
    setTimeout(() => {
      this.props.clearTooltip();
    }, delay);
  };

  render() {
    const { t, ignitionOn, supportAutorunEngineDelay, currentDevice } = this.props;
    const { autorunMenuOpened } = this.state;
    const disabled = isRecentAction(this.props.ignitionState);
    const containerClass = cx('control-panel__button', {
      'aside__drop-down--open': autorunMenuOpened,
      'control-panel__button_shape_quadratic': this.props.quadratic,
    });
    const buttonClass = cx('control-button', 'control-button_type_engine', {
      'control-button_state_active': ignitionOn,
      'control-button_shape_quadratic': this.props.quadratic,
    });

    return (
      <div className={containerClass} disabled={disabled}>
        <div
          className={buttonClass}
          disabled={disabled}
          onMouseDown={this.mouseDownHandler}
          onMouseUp={this.mouseUpHandler}
          onClick={this.clickHandler}
        >
          <span className="control-button__icon" />
          {ignitionOn && <div className="control-button__text">{t('dashboard-sidebar:igniteOff')}</div> }
          {(supportAutorunEngineDelay && !ignitionOn) && <div className="control-button__text">
            {t('dashboard-sidebar:igniteOn')}
            <div
              role="button"
              tabIndex={0}
              ref={(btn) => { this.openAutorunBtn = btn; }}
              onClick={(e) => {
                e.preventDefault();
                this.setState({ autorunMenuOpened: !this.state.autorunMenuOpened });
              }}
              className="control-button__hint hint"
            >
              <span className="right">
                {t('dashboard-sidebar:engineWorkTime')}
              </span>
            </div>
          </div>
          }
          {(!supportAutorunEngineDelay && !ignitionOn) && <div className="control-button__text">{t('dashboard-sidebar:igniteOn')}</div> }
        </div >
        {this.state.autorunMenuOpened &&
        <IgnitionAutorun
          setWebastoOn={this.setWebastoOn}
          setSeconds={this.setSeconds}
          onClickOutside={this.onAutorunClickOutside}
          currentDevice={currentDevice}
        />}
      </div>
    );
  }
}

IgnitionButton.propTypes = {
  handleAnimationState: PropTypes.func.isRequired,
  quadratic: PropTypes.bool.isRequired,
};

IgnitionButton.WrappedComponent.propTypes = {
  deviceId: PropTypes.number.isRequired,
  ignitionOn: PropTypes.bool.isRequired,
  ignitionState: PropTypes.number.isRequired,
  supportAutorunEngineDelay: PropTypes.bool.isRequired,
  currentDevice: PropTypes.shape({
    id: PropTypes.number,
    autorunEngineDelayInSeconds: PropTypes.number,
  }).isRequired,
  toggleIgnition: PropTypes.func.isRequired,
  toggleWebasto: PropTypes.func.isRequired,
  clearTooltip: PropTypes.func.isRequired,
  setTooltip: PropTypes.func.isRequired,
  handleAutorunEngineDelayInSeconds: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/DeviceControl/Ignition/index.js